import { DrawnMol } from '@moleculeone/types';
import { V4, expandToMinSize, expandToSquare } from '@moleculeone/utils';
import cx from 'classnames';
import { MouseEventHandler, ReactNode, useMemo } from 'react';

import { DisconnectionData, SVGMol } from './SVGMol';
import { SVGMolSpace } from './SVGMolSpace';

export interface BaseCompoundProps {
  className?: string;
  drawnMol: DrawnMol;
  size?: number[];
  border?: number;
  before?: ReactNode;
  after?: ReactNode;
  cutData?: DisconnectionData;
  onClick?: MouseEventHandler;
  onMouseDown?: MouseEventHandler;
  onMouseUp?: MouseEventHandler;
  onMouseMove?: MouseEventHandler;
}

export { BOND_CUT_APPLIED, BOND_CUT_DESIRED, SVGMol } from './SVGMol';
export { SVGMolSpace } from './SVGMolSpace';

export type { Disconnection, DisconnectionData } from './SVGMol';

export function BaseCompound(props: BaseCompoundProps) {
  const {
    className,
    drawnMol,
    size = [100, 100, 0],
    border = 20,
    before,
    after,
    cutData,
    onClick,
    onMouseDown,
    onMouseUp,
    onMouseMove,
  } = props;

  const viewport = useMemo(() => expandToSquare(expandToMinSize(drawnMol.bbox, V4.fromArray(size))), [drawnMol, size]);

  return (
    <SVGMolSpace
      className={cx('svg-mol-space', className)}
      viewport={viewport}
      border={border}
      onMouseDown={onMouseDown}
      onMouseUp={onClick ?? onMouseUp}
      onMouseMove={onMouseMove}
    >
      {before}
      <SVGMol drawnMol={drawnMol} cutData={cutData} />
      {after}
    </SVGMolSpace>
  );
}
